module.exports = __webpack_public_path__ + "img/outlet-banner.7417d2dc.png";